import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../slices/UserSlice';
import collectionReducer from '../slices/CollectionSlice';

export default configureStore({
  reducer: {
    user: userReducer,
    collection: collectionReducer

  },
});